export type TourStopMapRole = 'start' | 'intermediate' | 'destination' | 'start-destination';

export const getTourStopMapRole = (index: number, stopCount: number): TourStopMapRole => {
    if (stopCount === 1) {
        return 'start-destination';
    }
    if (index === 0) {
        return 'start';
    }
    if (index === stopCount - 1) {
        return 'destination';
    }
    return 'intermediate';
};
